import { IPortalContactResponse } from "shared";

import { emptySplitApi } from "../baseApi";
import { PortalCacheTags } from "../cacheTags";

export const contactApi = emptySplitApi.injectEndpoints({
  endpoints: builder => ({
    fetchContact: builder.query<IPortalContactResponse, { code: string; sessionId: string}>({
      query: ({ code, sessionId }) => ({
        url: `contact/code/${code}`,
        method: `GET`,
        headers: {
          [`X-Portal-Session`]: sessionId,
          [`X-Portal-Hash-Code`]: code,
        },
      }),
      providesTags: res => [{ type: PortalCacheTags.Contact, id: res?.statement?.contact?.id }],
    }),
    smsOptOut: builder.mutation<void, { code: string; smsOptOut: boolean; sessionId: string }>({
      query: ({ code, smsOptOut, sessionId }) => ({
        url: `contact/code/${code}/smsOptOut`,
        method: `PUT`,
        data: { smsOptOut },
        headers: {
          [`X-Portal-Session`]: sessionId,
          [`X-Portal-Hash-Code`]: code,
        },
      }),
      invalidatesTags: [{ type: PortalCacheTags.Contact }],
    }),
  }),
});

export const {
  useFetchContactQuery,
  useSmsOptOutMutation,
} = contactApi;
